import { useEffect, useReducer } from 'react';

const initialState = {
  entity: null,
  error: '',
  status: 'loading',
};

function reducer(state, action) {
  switch (action.type) {
    case 'success':
      return { entity: action.entity, error: '', status: 'success' };
    case 'error':
      return { entity: null, error: action.error, status: 'error' };
    default:
      return state;
  }
}

export function usePreIpoEntity(cik, apiBaseUrl) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (!cik) return undefined;
    const controller = new AbortController();

    fetch(`${apiBaseUrl}/api/pre-ipo/entities/${encodeURIComponent(cik)}`, {
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    })
      .then(async (response) => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(payload?.error || 'Unable to load this SEC entity.');
        }
        dispatch({ type: 'success', entity: payload?.entity || null });
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return;
        dispatch({ type: 'error', error: error?.message || 'Unable to load this SEC entity.' });
      });

    return () => controller.abort();
  }, [apiBaseUrl, cik]);

  return state;
}
